// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__32iU8","dragIcon":"SortableItem_dragIcon__2bD4g","disabled":"SortableItem_disabled__1n1Q3"};